export default class PopoverMenuController {
  constructor($element, $document, $scope, $transitions, $state) {
    'ngInject';

    this.element = $element[0];
    this.$document = $document;
    this.$scope = $scope;
    this.$state = $state;
    this.$transitions = $transitions;

    this.labelList = [
      {
        sref: 'engineer.members.map',
        label: 'members map',
      },
      {
        sref: 'engineer.members.member-list',
        label: 'members list',
      },
    ];
  }

  $onInit() {
    this.handleSelect();

    this.$transitions.onSuccess({ from: 'engineer.members.*' }, () => {
      this.selectedLabel = '';
    });
  }

  handleSelect(currentSref = this.$state.current.name) {
    this.opened = false;

    const labelEntry = this.labelList.find((labelEntry) => {
      return labelEntry.sref === currentSref;
    });

    if (!labelEntry) {
      return;
    }

    this.selectedLabel = labelEntry.label;
  }

  $postLink() {
    this.handleHidding();
  }

  handleHidding() {
    const clickEvent = 'click';
    this.$document.on(clickEvent, (event) => {
      if (!this.opened) {
        return;
      }

      if (event.target === this.element || this.element.contains(event.target)) {
        return;
      }
      this.opened = false;
      this.$scope.$apply();
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/screens/engineer/components/popover-menu/popover-menu.controller.js